import { UsuarioInfor } from './../models/UsuarioInfor';

import { Post, Get } from "./ServiceBase";

// const urlBase = `${ServiceBase.instance.defaults.baseURL}unidade/`;

export const Logar = async (login: string, senha: string) => {
    let rest = await Post<any>('UsuarioInfor', {
        login: login,
        senha: senha
    })
    if (!rest) return;
    const { token, usuario } = rest as { token: string, usuario: UsuarioInfor };
    return {
        token,
        usuario
    }
}

export const AbrirNoInfor = async (url) => {
    let rest = await Get<any>('UsuarioInfor/open/' + url)

}